import { useEffect, useRef } from "react";
import "./eventList.css";
import { useVideoPlayer } from "../../../Contexts/contexts";
import { handlePlayEvent } from "../../../functions";
import { useGameStore } from "../../../store";
import { MergedGpEventResponse } from "../../../types";

export function EventListArrowHandler() {
	const { setFollowVideo, jumpBetweenIntervals, mergedEvents } = useGameStore();
	const { playerRef } = useVideoPlayer();

	const lastEventRef = useRef<MergedGpEventResponse | null>(null);

	useEffect(() => {
		if (!jumpBetweenIntervals) {
			return;
		}

		const handleKeyDown = (event: KeyboardEvent) => {
			if (playerRef?.current) {
				const currentTime = playerRef.current.currentTime * 1000;

				let mergedEvent: MergedGpEventResponse | undefined;

				if (event.key === "ArrowUp") {
					event.preventDefault();
					mergedEvent = mergedEvents.findLast((me) => me.endTime < currentTime);
				}

				if (event.key === "ArrowDown") {
					event.preventDefault();
					mergedEvent = mergedEvents.find((me) => me.startTime > currentTime);
				}
				if (mergedEvent) {
					if (lastEventRef.current && lastEventRef.current.id === mergedEvent.id) {
						return;
					}
					handlePlayEvent(playerRef, mergedEvent.startTime);
					setFollowVideo(true);
					lastEventRef.current = mergedEvent;
				}
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		return () => {
			console.log("Removing keydown event listener");
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [jumpBetweenIntervals]);

	return null;
}
